import React from "react"
import BrickHistory from "../components/brick-history"
import Brick from '../components/brick'

function BrickWall({news, history})
{
    const bricks = news.edges.map(({node}, index) => {
        var styles = ["brick-1 span-4", "brick-2", "brick-4", "brick-5", "brick-6", "brick-7" ];
        var hidecaption = (index > 1);
        var brick = (index === 2) ? <><BrickHistory key="history" data={history}/><Brick key={`brick${index}`} slug={node.fields.slug} url={node.frontmatter.url} thumbnail={node.frontmatter.thumbnail} caption={node.frontmatter.caption} styles={styles[index]} hideCaption={hidecaption}/></> : <Brick key={`brick${index}`} slug={node.fields.slug} url={node.frontmatter.url} thumbnail={node.frontmatter.thumbnail} caption={node.frontmatter.caption} styles={styles[index]} hideCaption={hidecaption}/>
        return brick;
    })

    return (
        <div className="container">
            <div className="brick-wall">
                {bricks}
            </div>
        </div>
    )
}

export default BrickWall